// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"AccountPersonalInfosPage_layoutWrapperMain__2ZDS4"};